/**
 * @date 03/14/2017
 * @copyright 2016 Empower Retirement
 * @description
 *
 * Used to communicate with the API.
 *
 */

/**
 * Logger.
 */
import ExternalLogger from "../../logger/ExternalLogger";
import StringUtil from "../../util/StringUtil";

/**
 * The constructor's parameters are "injected" via AJS's IoC.
 *
 * @constructor
 */
var TransactionMessagingFactory = function ($resource, $http, $q, $window) {
    var logger = ExternalLogger.getInstance("TransactionMessagingFactory");

    //-----------------------------------------------------------------------
    // PROTECTED METHODS
    //-----------------------------------------------------------------------

    /**
     * Makes a HTTP GET request to the API endpoint for dividend election data. Internally handles the success and fault
     * of that HTTP request.
     *
     * @returns {Promise} A promise to the future resolution of the HTTP request.
     */
    var getTransactionMessages = function (groupId, functionCode) {
        if (!groupId || !functionCode) {
            return $q.reject(
                new Error("Get dividend params requires valid `groupId` and `functionCode` fields.")
            );
        }

        logger.info("getTransactionMessages( groupId = {0}, functionCode = {1} )", [
            groupId,
            functionCode
        ]);

        var url =
            __baseApiUrl__ +
            "/participant-web-services/rest/nonauth/bulletins/group/{groupId}/function/{functionCode}";
        var params = {
            groupId: groupId,
            functionCode: functionCode
        };
        var request = {
            url: StringUtil.supplant(url, params),
            method: "GET"
        };

        var getTransactionMessagesSuccess = function (data) {
            logger.debug("getTransactionMessagesSuccess()");
            return data;
        };

        var getTransactionMessagesFault = function (fault) {
            logger.warn("getTransactionMessagesFault( {0} )", [fault]);
            return $q.reject(fault);
        };

        return $http(request).then(getTransactionMessagesSuccess, getTransactionMessagesFault);
    };

    //-----------------------------------------------------------------------
    // EXPOSED API
    //-----------------------------------------------------------------------

    return {
        getTransactionMessages: getTransactionMessages
    };
};

TransactionMessagingFactory.$inject = ["$resource", "$http", "$q", "$window"];
export default TransactionMessagingFactory;
